import { useAtom } from 'jotai'

import { calendarFullscreenAtom, showNoteViewAtom } from '../atoms/calendar'

interface UseCalendarUIReturn {
  // Fullscreen mode
  fullscreen: boolean
  setFullscreen: (fullscreen: boolean) => void

  // Note view visibility
  showNoteView: boolean
  setShowNoteView: (show: boolean) => void
}

/**
 * Hook for managing calendar UI state.
 *
 * This hook provides access to calendar UI atoms for components
 * that need to control calendar display settings.
 */
export const useCalendarUI = (): UseCalendarUIReturn => {
  const [fullscreen, setFullscreenInternal] = useAtom(calendarFullscreenAtom)
  const [showNoteView, setShowNoteViewInternal] = useAtom(showNoteViewAtom)

  // Session storage only (no backend persistence for temporary UI state)
  const setFullscreen = (value: boolean) => {
    setFullscreenInternal(value)
  }

  const setShowNoteView = (value: boolean) => {
    setShowNoteViewInternal(value)
  }

  return {
    fullscreen,
    setFullscreen,
    showNoteView,
    setShowNoteView,
  }
}
